import AdminLayout from "../../../components/admin/layout/AdminLayout";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";
import SurveySettlement from "../../../components/common/survey/SurveySettlement";

function SurveySettlementPage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <SurveySettlement />
    </AdminLayout>
  );
}

export default SurveySettlementPage;
